import React, { useState } from 'react';

import './sections-desk.scss';

const functions = {
  import: () => {
    window.postMessage({ command: 'sbrowser-import' });
    console.log('Sbrowser-import sent');
  }
}

const Button = ({ button }) => {
  if (button && button.href) {
    return (
      <a href={button.href} >
        <button type="button" className="custom-button red">{button.desc}</button>
      </a>
    );
  } else if (button && button.func) {
    return (<button type="button" className="custom-button red" onClick={functions[button.func]}>{button.desc}</button>)
  }

  return null;
};

const Section = ({
  props,
  props: { h, p, reverseContent, image, button, id },
}) => {
  return (
    <section id={id} className="full feature gradient">
      <div className={`content-wrapper ${reverseContent ? 'reverse' : null}`}>
        <div className="image-wrap">
          <img src={image} />
        </div>
        <div className="section-content">
          <div className="bg-circle" />
          <h2>{h}</h2>
          <div className="small-dash" />
          <p dangerouslySetInnerHTML={{ __html: p}} />
          <Button button={button} />
          {props.contentImg ? <img src={props.contentImg} /> : null}
        </div>
      </div>
    </section>
  );
};

class ContentSectionDesk extends React.PureComponent {
  render() {
    return (
      <Section props={this.props.sectionContent} />
    );
  }
}

export default ContentSectionDesk;
